import { Component, HostListener, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { FormBuilder } from '@angular/forms'
import { SharedServices } from '../../../../services/shared.services'
import { ModalService } from '../../../../services/modal.service'
import { ConfigService } from '@services/config.service'

@Component({
    selector: 'app-moda-clinicl-audit',
    templateUrl: './modal-audit.component.html',
    styleUrls: [
        '../../../../stagingcss/root-ui-view.component.css',
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/main-view.component.css',
        '../../../../stagingcss/lui-select.component.css',
    ],
})

export class ModalAuditComponent implements OnInit {

    hiddenModalAccessDetail = 'hidden'
    hiddenModalAccountDetail = 'hidden'
    getAccessLog: object = null
    getAccountLog: object = null
    operatorNameClient: String = ''
    hostKeyboard: String = 'ModalAuditComponent-hostKeyboard'

    constructor(private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private _sharedService: SharedServices,
                private modalService: ModalService,
                public configService: ConfigService) {
        this.modalService.changeEmitted$.subscribe(
            success => {
                if (success) {
                    if (success.modal === 'AccessLog') {
                        this.hiddenModalAccessDetail = 'active'
                        this.getAccessLog = success                      
                        this.operatorNameClient = success['operatorNameClient'] ? success['operatorNameClient'] : ''
                      
                    } else if (success.modal === 'AccountLog') {
                        this.hiddenModalAccountDetail = 'active'
                        this.getAccountLog = success
                        this.operatorNameClient = success['operatorNameClient'] ? success['operatorNameClient'] : ''
             
                    }
                }
            })
    }

    ngOnInit() {
    }

    hidenModalAccessDetail() {
        this.hiddenModalAccessDetail = 'hidden'
    }

    hidenModalAccountDetail() {
        this.hiddenModalAccountDetail = 'hidden'
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent, ModalAuditComponent: string = 'ModalAuditComponent-hostKeyboard') {
        if (ModalAuditComponent === this.hostKeyboard) {
            const keyPressed = event.keyCode
            if (keyPressed === 27) {
                event.preventDefault()
                this.hidenModalAccessDetail()
                this.hidenModalAccountDetail()
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/clinic/audit/modal-audit.component.ts